module.exports = __webpack_public_path__ + "img/cattunnel45.480a5399.jpg";